/*
 * @Author: Json Chen
 * @Date: 2021-06-16 17:55:51
 * @LastEditTime: 2021-06-16 17:56:19
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/LinkLibrary/config.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/linkLibrary',
    name: getI18n('settings.list.linkLibrary'),
  },
];
